export const API = {
  URL: process.env.REACT_APP_API_URL || "https://api.sendupdates.ai",
  TIMEOUT: 10_000,
};

// Supabase configuration - using consistent variable names
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY; // Fixed: was REACT_APP_SUPABASE_KEY
export const API_URL = process.env.REACT_APP_API_URL || "https://api.sendupdates.ai";

// Stripe
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY!;
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL!;

// Hotjar
export const HOTJAR_SITE_ID = process.env.REACT_APP_HOTJAR_SITE_ID;
export const HOTJAR_VERSION = process.env.REACT_APP_HOTJAR_VERSION || "6";

// Build identifier — set by CI (github.run_number); 'dev' in local development
export const BUILD_HASH = process.env.REACT_APP_BUILD_HASH || 'dev';

// Environment validation helper
export const validateEnvironment = () => {
  const missing = [];

  if (!SUPABASE_URL) missing.push("REACT_APP_SUPABASE_URL");
  if (!SUPABASE_ANON_KEY) missing.push("REACT_APP_SUPABASE_ANON_KEY");
  if (!STRIPE_PUBLIC_KEY) missing.push("REACT_APP_STRIPE_PUBLIC_KEY");
  if (!FRONTEND_URL) missing.push("REACT_APP_FRONTEND_URL");

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(", ")}. ` +
        "Please check your .env file or deployment configuration."
    );
  }
};
